import { gql } from '@apollo/client';

export default class InventoryModuleSubscription {
    static VEHICLE_BLOCKING_STATUS_CHANGED = gql`
        subscription vehicleRecordBlockingStatusChanged(
            $stockNumber: Int!
        ) {
            vehicleRecordBlockingStatusChanged(
                stockNumber: $stockNumber
            ) {
                isEditing
                editingById
                editingBy
                stockNumber
            }
        }
    `;

    static REPAIRS_ANALYSIS_COMPLETED = gql`
        subscription repairsAnalysisCompletedByAI(
            $stockNumber: Int!
        ) {
            repairsAnalysisCompletedByAI(
                stockNumber: $stockNumber
            )
        }
    `;

    static INSPECTION_ITEM_IMAGES_UPDATED = gql`
        subscription inspectionItemImagesUpdated($stockNumber: Int!) {
            inspectionItemImagesUpdated(stockNumber: $stockNumber) {
                vehicleInspectionItemId
                reconInspectionItemId
                imageCount
            }
        }
    `;

    static REPAIR_ITEM_IMAGES_UPDATED = gql`
        subscription repairItemImagesUpdated($stockNumber: Int!) {
            repairItemImagesUpdated(stockNumber: $stockNumber) {
                vehicleRepairItemId
                vehicleInspectionItemId
                imageCount
            }
        }
    `;
}
